import React from 'react';
import { 
  Grid,
	GridColumn,
	GridRow,
	Header,
	Image,
} from 'semantic-ui-react';

export default function TimberSelection() {

	const h1Style = {
		fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "4em",
  }

	const h1StyleMobile = {
		fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "3em",
  }

	const h2Style = {
		fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "1.2em",
		fontweight: "normal",
  }

	const timberImage = {
    height: "13em",
		width: "13em",
		border: "solid 0.4em #92A082",
  }

  return (
		<div>
			<Grid>
				<GridRow columns={1} style={{ padding: "0em 0em 4em 0em" }}>
					<GridColumn only="computer tablet" textAlign='center'>
						<Header
							as='h1'
							content='Our Tasmanian timber selection'
							style={h1Style}
						/>
					</GridColumn>
					<GridColumn only="mobile" textAlign='center'>
						<Header
							as='h1'
							content='Our Tasmanian timber selection'
							style={h1StyleMobile}
						/>
					</GridColumn>
				</GridRow>
			</Grid>

			<Grid stackable container centered>
				<GridRow only="computer" columns={5} style={{ padding: "0em 1em 0em 1em" }}>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 3em 0em" }}>
						<Image
							src="./blackheartSassafras.webp"
							title="Tasmanian Blackheart Sassafras"
							alt="Surface of Tasmanian blackheart sassafras timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Blackheart Sassafras'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./blackwood.webp"
							title="Tasmanian Blackwood"
							alt="Surface of Tasmanian blackwood timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Blackwood'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./huonPine.webp"
							title="Tasmanian Huon Pine"
							alt="Surface of Tasmanian huon pine timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Huon Pine'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./myrtle.webp"
							title="Tasmanian Myrtle"
							alt="Surface of Tasmanian myrtle timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Myrtle'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./tasOak.webp"
							title="Tasmanian Oak"
							alt="Surface of Tasmanian oak timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Tas Oak'
							style={h2Style}
						/>
					</GridColumn>
				</GridRow>

				<GridRow only="tablet mobile" columns={3} centered style={{ padding: "0em 1em 0em 1em" }}>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./blackheartSassafras.webp"
							title="Tasmanian Blackheart Sassafras"
							alt="Surface of Tasmanian blackheart sassafras timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Blackheart Sassafras'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./blackwood.webp"
							title="Tasmanian Blackwood"
							alt="Surface of Tasmanian blackwood timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Blackwood'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./huonPine.webp"
							title="Tasmanian Huon Pine"
							alt="Surface of Tasmanian huon pine timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Huon Pine'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./myrtle.webp"
							title="Tasmanian Myrtle"
							alt="Surface of Tasmanian myrtle timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Myrtle'
							style={h2Style}
						/>
					</GridColumn>
					<GridColumn textAlign='center' style={{ padding: "0em 0em 4em 0em" }}>
						<Image
							src="./tasOak.webp"
							title="Tasmanian Oak"
							alt="Surface of Tasmanian oak timber"
							circular
							centered
							style={timberImage}
						/>
						<Header
							as='h2'
							content='Tas Oak'
							style={h2Style}
						/>
					</GridColumn>
				</GridRow>
			</Grid>
		</div>
  );
};